module.exports = "/_next/static/images/boxing-5011588fd37088f0cacc7f3e4ef1c84a.png";